document.addEventListener('DOMContentLoaded', function() {
    if(document.body.classList.contains('template--page-landing') || document.body.classList.contains('template--page-shop-by-goal')) {
      var container = document.getElementById('MainContent');
    }
    else {
      var container = document.getElementById('ProductGridContainer');
    }

    function getSelectedVariant(formId) {
      let fieldsets = Array.from(document.querySelectorAll('.quick-add__variants-'+formId));
      let selectedOptions = fieldsets.map((fieldset) => {
        return fieldset.value;
      });

      let variantData = JSON.parse(document.querySelector('#variantDataJSON-'+formId).textContent);
      let selectedVariant = variantData.find((variant) => {
        return !variant.options.map((option, index) => {
          return selectedOptions[index] === option;
        }).includes(false);
      });

      return selectedVariant;
    }

    function getSelectedSubscription(formId, selector, selectedValue) {
      if(selector.options[selector.selectedIndex].getAttribute('data-purchase-type') == 'one-time') {
        selectedValue = selectedValue+'onetime'; // to differentiate from the product's subscription option
      }
      let subData = JSON.parse(document.querySelector('#subscriptionJSON-'+formId).textContent);
      let selectedOption = subData.find((variant) => {
        if(variant.id == selectedValue) {
          return variant;
        }
      });
      return selectedOption;
    }

    function onItemVariantChange(evt) {
      let formId = event.target.getAttribute('form');
      let quickAddForm = document.querySelector('#'+formId);

      let selectedVariant = getSelectedVariant(formId);
      quickAddForm.querySelector('input[name="id"]').value = selectedVariant.id

      // If product has subscription option, get current subscription option
      if(document.querySelector('#subscriptionJSON-'+formId)) {
        selectedVariant = getSelectedSubscription(formId, document.querySelector('#productOptions-'+formId), document.querySelector('#productOptions-'+formId).value);
      }

      toggleQuickAddButton(selectedVariant.available, true, quickAddForm);
      itemUpdatePrice(selectedVariant, document.querySelector('.price--'+formId));
    }

    function onSubOptionSelectorChange(evt) {
      let formId = event.target.getAttribute('form');
      let quickAddForm = document.querySelector('#'+formId);
      let selector = document.querySelector('#productOptions-'+formId)
      let hiddenInput = quickAddForm.querySelector('input[name="id"]');
      let subInput = quickAddForm.querySelector('input[name="selling_plan"]');

      let selectedValue = selector.value;
      hiddenInput.value = selectedValue;

      // If product has variants, get current selected variant
      if(document.querySelector('.quick-add__variants-'+formId)) {
        let selectedProductVariant = getSelectedVariant(formId);
        hiddenInput.value = selectedProductVariant.id;
      }

      if(selector.options[selector.selectedIndex].getAttribute('data-purchase-type') == 'one-time') {
        if(subInput != null) {
          subInput.remove();
        }
      }
      let selectedVariant = getSelectedSubscription(formId, selector, selectedValue);

      if(selectedVariant != undefined) {
        let selectedSellingPlan = selectedVariant.selling_plan_id;

        if(subInput != null) {
          subInput.value = selectedSellingPlan;
        }
        else {
          subInput = document.createElement("input");
          subInput.type = "hidden";
          subInput.value = selectedSellingPlan;
          subInput.name="selling_plan";
          quickAddForm.insertBefore(subInput, quickAddForm.querySelector('button[type=submit]'));
        }

        toggleQuickAddButton(selectedVariant.available, true, quickAddForm);
        itemUpdatePrice(selectedVariant, document.querySelector('.price--'+formId));
      }
    }

    function toggleQuickAddButton(available, modifyClass = true, productForm) {
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (available) {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      } else {
        addButton.setAttribute('disabled', 'disabled');
        addButtonText.textContent = window.variantStrings.soldOut;
      }
      if (!modifyClass) return;
    }

    function itemUpdatePrice(selectedVariant, priceWrapper) {
      let compareAtPrice = selectedVariant.compare_at_price;
      let compareAtPriceMoney = selectedVariant.compare_at_price_money;
      let priceMoney = selectedVariant.price_money;

      if(priceWrapper != null) {
        priceWrapper.querySelector('.price-item--regular').textContent = priceMoney;
        if(compareAtPrice != null && compareAtPrice > 0 && compareAtPriceMoney != priceMoney) {
          priceWrapper.querySelector('.price__sale .price-item--regular').textContent=compareAtPriceMoney;
          priceWrapper.querySelector('.price-item--sale').textContent=priceMoney;
          priceWrapper.classList.add('price--on-sale');
        }
        else {
          priceWrapper.classList.remove('price--on-sale');
        }
      }
    }

    container.addEventListener('change', e => {
      const { target } = e;
      if (target.matches('.quick-add__variants')) {
        onItemVariantChange(target);
      }
      else if (target.matches('.quick-add__select')) {
        onSubOptionSelectorChange(target);
      }
    });

  });
